export const USER_TYPES = {
  NS6989: {
    id: 'ns6989',
    label: 'NS6989 ユーザー',
    dashboardPath: '/ns6989/main',
    defaultRedirect: '/ns6989/main',
    iconPath: null
  },
  CHOWA: {
    id: 'chowa',
    label: '調和工業 青柳様',
    dashboardPath: '/chowa/main',
    defaultRedirect: '/chowa/main',
    iconPath: '/user_icon/CHOWA_C.jpg'
  },
  KSK: {
    id: 'ksk',
    label: 'KSK ユーザー',
    dashboardPath: '/ksk/main',
    defaultRedirect: '/ksk/main',
    iconPath: null
  }
};

export const getRedirectPath = (userType) => {
  const config = Object.values(USER_TYPES).find(type => type.id === userType);
  return config ? config.defaultRedirect : '/error';
};

export const getUserTypeLabel = (userType) => {
  const config = Object.values(USER_TYPES).find(type => type.id === userType);
  return config ? config.label : 'Unknown User';
};

export const isValidUserType = (userType) => {
  return Object.values(USER_TYPES).some(type => type.id === userType);
};

export const getUserIcon = (userType) => {
  const config = Object.values(USER_TYPES).find(type => type.id === userType);
  return config?.iconPath || null;
}; 